module.exports = __webpack_public_path__ + "media/wyposazenie/ilosc-drzwi-0bfbf496.png";